// Contact API
import {
    RequestConfigFunction, SelectorConfig,
} from 'app/types/request.types'
import {
    Contact,
} from 'app/Apps/ContactManagement/Contacts/Contacts.types'

type ContactRequests = {
    name: string,
    getContactsChangeHistory: (id: number) => { customUrl: string, method: string, name: string },
    get: RequestConfigFunction<{ id: number }>,
    create: RequestConfigFunction<{ data: Record<string, any> }>,
    update: RequestConfigFunction<{ data: Record<string, any> }>,
    archive: RequestConfigFunction<{ id: number }>,
    restore: RequestConfigFunction<{ id: number }>,
    sapEmployee: RequestConfigFunction<{ id: number }>,
    sendContactToSap: RequestConfigFunction<{ contactId: number }>,
    filterRequestSelector: RequestConfigFunction,
    selector: SelectorConfig<{ contactName: string, id: number }[]>,
    filterRequest: RequestConfigFunction<{ params?: Record<string, any> }>,
    duplication: RequestConfigFunction<{ data: { contactName: string, email: string } }>,
    unprospectData: RequestConfigFunction,
}

const contactRequests: ContactRequests = {
    name: 'Modification',
    getContactsChangeHistory: (id) => {
        return {
            customUrl: `contact/${id}/modifications`,
            method: 'GET',
            name: 'Contact',
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `contact/${id}`,
            method: 'GET',
        }
    },
    create: ({
        data,
    }) => {
        return {
            url: 'contact',
            method: 'POST',
            data,
        }
    },
    update: ({
        data,
    }) => {
        return {
            url: 'contact',
            method: 'PUT',
            data,
        }
    },
    archive: ({
        id,
    }) => {
        return {
            url: `contact/${id}/archive`,
            method: 'PATCH',
        }
    },
    restore: ({
        id,
    }) => {
        return {
            url: `contact/${id}/restore`,
            method: 'PATCH',
        }
    },
    duplication: ({
        data,
    }) => {
        return {
            url: 'contact/duplicate-check',
            method: 'POST',
            data,
        }
    },
    sapEmployee: ({
        id,
    }) => {
        return {
            url: `contact/${id}/sap-employee-data`,
            method: 'PATCH',
        }
    },
    sendContactToSap: ({
        contactId,
    }) => {
        return {
            url: `contact/${contactId}/sap-sending`,
            method: 'PATCH',
        }
    },
    filterRequestSelector: () => {
        return {
            url: 'contact/filter-request/selector',
            method: 'POST',
        }
    },
    selector: {
        url: 'contact/filter-request/selector',
        convertion: (contacts) => {
            return contacts.map(({
                contactName, id,
            }) => {
                return {
                    label: contactName,
                    value: id,
                    id,
                }
            })
        },
    },
    filterRequest: ({
        params = {},
    } = {}) => {
        return {
            url: 'contact/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    unprospectData: () => {
        return {
            url: 'contact/unprospect-data',
            method: 'PATCH',
        }
    },
}

export const contactSelectionConfig: SelectorConfig<Contact[]> = {
    url: contactRequests.filterRequestSelector().url,
    convertion: (contacts) => {
        return contacts.map(({
            contactName, id,
        }) => {
            return {
                label: contactName,
                value: id,
                id,
            }
        })
    },
}

export default contactRequests
